import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';


import { MantineProvider, createTheme } from '@mantine/core';
import { SocketProvider } from './contexts/SocketContext';


const theme = createTheme({
  fontFamily: 'Inter, sans-serif',
  fontFamilyMonospace: 'JetBrains Mono, Monaco, Courier, monospace',
  primaryColor: 'yellow',
  defaultRadius: 'md',
  components: {
    Card: {
      defaultProps: {
        withBorder: true,
        radius: 'lg',
        shadow: 'sm',
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
        color: 'yellow',
        autoContrast: true,
      },
    },
    ActionIcon: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={ theme } defaultColorScheme="light">
      <SocketProvider>
        <App />
      </SocketProvider>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
